(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-order-home/assets/javascript/pages/order-home/choose/page.js') >= 0) return;  svs.modules.push('/modules/tickets-order-home/assets/javascript/pages/order-home/choose/page.js');
"use strict";

const {
  useOrderHomeContext
} = svs.ticketsOrderHome.context;
const Envelope = svs.tur.Envelope;
const {
  TicketOrderCounterWithPrice
} = svs.ticketsOrderHome.components;
const CartBottomSheetContinue = svs.ticketsOrderHome.orderHome.components.CartBottomSheetContinue;
const {
  trackOrderHomeCartSelections
} = svs.ticketgames.ticketUtility.utils.tracking;
const {
  RECEIVER
} = svs.ticketsOrderHome.routes.ORDER_HOME;
const {
  isMaximumQuantityWeightReachedForTicket
} = svs.ticketsOrderHome.utils;
const Body = _ref => {
  let {
    ticket
  } = _ref;
  const {
    name,
    description,
    price
  } = ticket;
  if (!name || !description || !price) {
    return null;
  }
  const productNameAndPrice = RegExp(/[0-9]{2,3}\b\skr\b/g).test(name.toLowerCase()) ? name : "".concat(name, " ").concat(price, " kr");
  return React.createElement("div", null, React.createElement("div", {
    className: "h2 f-content fw-500"
  }, productNameAndPrice), React.createElement("p", null, description));
};
setGlobal('svs.ticketsOrderHome.pages.Choose', _ref2 => {
  let {
    history
  } = _ref2;
  const {
    state,
    incrementOrderCount,
    decrementOrderCount
  } = useOrderHomeContext();
  const getCartTicket = id => {
    const cartTicket = state.cart.tickets.find(ticket => ticket.id === id);
    if (cartTicket) {
      return cartTicket;
    }
    return {
      count: 0,
      totalPrice: 0,
      incrementDisabled: isMaximumQuantityWeightReachedForTicket({
        id
      }, state.cart.tickets)
    };
  };
  const {
    orderHomeTitle,
    orderHomeSubtitle
  } = svs.ticketsOrderHome.data.config.orderHome;
  const anyTicketReachesMaximumQuantity = state.availableTickets.some(ticket => getCartTicket(ticket.id).incrementDisabled);
  const onContinue = () => {
    trackOrderHomeCartSelections(state.cart.tickets);
    history.push(RECEIVER);
  };
  return React.createElement("div", {
    className: "order-home-choose-page"
  }, React.createElement("div", {
    className: "u-text-center f-body"
  }, React.createElement("h2", {
    className: "h2"
  }, orderHomeTitle), React.createElement("p", {
    className: "p order-home-choose-page-subtitle"
  }, orderHomeSubtitle)), React.createElement("div", {
    className: "tickets-order-home-envelopes"
  }, state.availableTickets.map(ticket => {
    const cartTicket = getCartTicket(ticket.id);
    const fullHeight = !anyTicketReachesMaximumQuantity || cartTicket.incrementDisabled;
    return React.createElement(Envelope, {
      branding: "triss",
      className: "u-flex u-flex-column envelope-order margin-top-1",
      image: ticket.image,
      key: ticket.id,
      repeatImage: Math.min(5, cartTicket.count)
    }, React.createElement("div", {
      className: "u-flex u-flex-column u-flex-justify-content-between padding-h-1 ".concat(fullHeight ? 'h100' : ''),
      "data-testid": "ticket-envelope-".concat(ticket.id)
    }, React.createElement(Body, {
      ticket: ticket
    }), React.createElement(TicketOrderCounterWithPrice, {
      count: cartTicket.count,
      incrementDisabled: cartTicket.incrementDisabled,
      onDecrement: () => decrementOrderCount(ticket.id),
      onIncrement: () => incrementOrderCount(ticket.id),
      totalPrice: cartTicket.totalPrice
    })));
  })), React.createElement(CartBottomSheetContinue, {
    onContinue: onContinue
  }));
});

 })(window);